import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { color, spacing } from '../theme'
import { H5 } from '../atoms/Heading'

const Title = styled(H5)`
   position: relative;
   z-index: 0;
   text-align: center;
   margin: ${spacing.m} 0;

   &:after {
      content: '';
      width: 100%;
      height: 2px;
      background: ${color.borderLight};
      display: block;
      position: absolute;
      top: 50%;
      z-index: -1;
   }

   span {
      padding: 0 ${spacing.m};
      position: relative;
      background: ${color.white};
   }
`

export const SectionHeader = ({ title }) => (
   <Title>{title && <span>{title}</span>}</Title>
)

SectionHeader.propTypes = {
   /**
    * Title
    */
   title: PropTypes.string.isRequired
}

SectionHeader.defaultProps = {
   title: ''
}
